import "./index.css";
import "./i18n"; // Initialize i18next

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { registerServiceWorker } from "./registerServiceWorker";
import reportWebVitals from "./reportWebVitals";
import { reportErrorToNR } from "./util/reportErrorToNR";
import { Sans } from "./util/sdk";
import { zendeskChatConfig } from "./zendeskChatConfig";

Sans.initializeSdk();

document.addEventListener("securitypolicyviolation", event => {
  // ZoomInfo attempts to bootstrap a blob-backed script that we intentionally block via CSP.
  // Suppress this known third-party noise so New Relic still highlights actionable CSP violations.
  const isBlockedZoomInfoBlobScript =
    event.violatedDirective === "script-src-elem" &&
    event.blockedURI === "blob" &&
    event.sourceFile.startsWith("https://js.zi-scripts.com/zi-tag.js");

  if (isBlockedZoomInfoBlobScript) {
    return;
  }

  reportErrorToNR(`CSP violation: ${event.blockedURI}`, {
    violatedDirective: event.violatedDirective,
    sourceFile: event.sourceFile,
    lineNumber: event.lineNumber,
  });
});

window.addEventListener("load", () => {
  registerServiceWorker();
  zendeskChatConfig();
});

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(window.location.host.startsWith("local") ? metric => console.log(metric) : undefined);
